import { render, staticRenderFns } from "./payment-method-accordion-v2.vue?vue&type=template&id=bbcd4b0e&"
import script from "./payment-method-accordion-v2.vue?vue&type=script&lang=ts&"
export * from "./payment-method-accordion-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports